import React from 'react';
import { money as moneyOf, money0 } from '../../utils/money';
import './NowViewing.css';

const money = (v) => moneyOf(v);
const rm0 = (v) => money0(v, null);

/**
 * Sticky strip under the topbar identifying whoever the reader has scrolled
 * to. This is where the identity indicator lives — NOT a sticky header
 * inside the person card, which would cover that card's own metrics for as
 * long as it's being read (see PersonSection.css / the approved mockup).
 * Purely presentational: `person`/`index`/`total` are handed down by
 * MeetingDetail's scroll-spy.
 */
export default function NowViewing({ person, index, total, topOffset }) {
  if (!person) return null;
  const isMarketing = person.kind === 'marketing';
  const p = person.pct == null ? 0 : Math.min(Math.max(person.pct, 0), 100);
  const capturedPct = person.capturedPct == null ? 0 : Math.min(Math.max(person.capturedPct, 0), 100);

  return (
    <div
      className="ml-now"
      data-testid="now-viewing"
      style={{ '--tone': person.tone, top: topOffset }}
    >
      <span className="ml-now-av" data-testid="now-av">{person.initials}</span>
      <span className="ml-now-name">{person.name}</span>
      <span className="ml-now-of">{index + 1} of {total}</span>
      {isMarketing ? (
        <span className="ml-now-fig"><span>Month-to-date team report</span></span>
      ) : person.tracksBookings ? (
        <span className="ml-now-fig ml-now-fig-booking">
          <span className="ml-now-figure-row">
            <span>Captured</span><b>{money(person.captured)}</b>
            <span className="ml-now-track"><i style={{ width: `${capturedPct}%` }} /></span>
            <span>{person.capturedTarget == null ? 'No target set' : `of ${rm0(person.capturedTarget)} target`}</span>
          </span>
          <span className="ml-now-figure-row">
            <span>Delivered</span><b>{money(person.delivered)}</b>
            <span className="ml-now-track"><i style={{ width: `${p}%` }} /></span>
            <span>{person.target == null ? 'No target set' : `of ${rm0(person.target)} target`}</span>
          </span>
        </span>
      ) : (
        <span className="ml-now-fig">
          <span>Delivered <b>{money(person.delivered)}</b></span>
          <span className="ml-now-track"><i style={{ width: `${p}%` }} /></span>
          <span>{person.target == null ? 'No target set' : `of ${rm0(person.target)} target`}</span>
        </span>
      )}
    </div>
  );
}
